// Pro-local copy of the consumer's "does this user hold a second factor?"
// answer (design I3, revised by spec 12.2). TOTP ONLY: a passkey never counts
// (it satisfies MFA only for a user who already has TOTP), and an email code is
// never a second factor (D1/I1). Kept local on purpose — the pro app must not
// import from the consumer app.

export type SecondFactorUser = {
  totpEnabled?: boolean | null;
  // Never read; declared so literals carrying passkeys stay assignable.
  passkeys?: readonly unknown[] | null;
};

export function hasSecondFactor(
  user: SecondFactorUser | null | undefined,
  totpOverride?: boolean,
): boolean {
  if (!user) return false;
  return totpOverride ?? user.totpEnabled === true;
}
